import { Box } from '@mui/material'

export function SendFieldBackdrop() {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: 'black',
        opacity: '0.5',
        marginBottom: '-10px',
        position: 'absolute',
      }}
    />
  )
}
